module.exports = __webpack_public_path__ + "static/media/exchange-items.389a8b24.png";